import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M25.9299 1.41003C34.8499 0.310026 37.4899 5.92004 37.4899 5.92004C37.4899 5.92004 40.8299 5.30002 43.5499 7.90002C45.8099 10.06 46.85 14.95 44.32 20.78C39.92 30.91 18.67 33.44 14.38 19.79C12.06 12.46 15.9399 2.65003 25.9299 1.41003Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M36.9899 5.37C36.9899 5.37 38.7899 10.97 33.0999 19.9"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M43.5398 8.30994C43.5398 8.30994 45.8198 13.91 36.3198 20.47"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M29.6801 1.56995C29.6801 1.56995 26.4501 3.17999 29.4901 19.61"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M23.2199 2.22998C23.2199 2.22998 18.7599 6.02994 24.8299 20.5599"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M20.1801 3.17993C20.1801 3.17993 16.67 11.8199 23.22 20.9399"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M14.7699 9.44995C14.7699 9.44995 13.1599 17.05 21.6999 21.8"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M56.52 30.47C51.11 23.71 38.8999 19.71 31.7999 19.71C24.6999 19.71 12.3799 23.71 6.96992 30.47C-2.72008 42.58 3.88996 69.22 3.88996 69.22C3.88996 69.22 4.54995 47.64 11.82 41.26C18.01 35.82 23.6899 37.91 31.7499 37.91C39.8099 37.91 45.4899 35.83 51.6799 41.26C58.9499 47.65 59.6099 69.22 59.6099 69.22C59.6099 69.22 66.21 42.58 56.52 30.47Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M25.1801 20.29C25.1801 20.29 22.7001 25.9 26.1701 37.96"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M17.5799 22.76C17.5799 22.76 13.6199 29.04 16.5899 38.45" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M14.12 24.58C14.12 24.58 8.84 30.03 10.98 41.59"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M6.63004 30.47C6.63004 30.47 1.07005 41.75 6.02005 53.48"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M38.3201 20.29C38.3201 20.29 40.8001 25.9 37.3301 37.96"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M45.9102 22.76C45.9102 22.76 49.8702 29.04 46.9002 38.45" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M49.3801 24.58C49.3801 24.58 54.6601 30.03 52.5201 41.59"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M56.8701 30.47C56.8701 30.47 62.4301 41.75 57.4801 53.48"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
  )
}
